import React, { useEffect, useState } from 'react';
import axios from 'axios';
//css
import '../../../styles/GlobalTradeshowSolution.css';
import { env } from '../../../env';

const GlobalTradeshowSolution = () => {
    const baseURL = env.REACT_APP_BACKEND_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState(1);
    const [paymentReference, setPaymentReference] = useState('');
    const [paymentToken, setPaymentToken] = useState('');
    const [userDetails, setUserDetails] = useState({
        appId: "2",
        region: "EMEA-01",
        presentmentCurrency: "EUR",
        intentType: "SAVE_CARD",
        timestamp: "",
        customerName: "Test Harness",
        countryCode: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zip: "",
        phone: '',
        email: "",
    });
    const [errorField, setErrorField] = useState('');
    const [errField, setErrField] = useState({});
    const [isAnyAddressFieldFilled, setIsAnyAddressFieldFilled] = useState(false);
    const [paymentResult, setPaymentResult] = useState({});
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [paymentError, setPaymentError] = useState('');
    const [simulatePayment, setSimulatePayment] = useState(false);
    const [supplyButtonId, setSupplyButtonId] = useState(false);

    const requiredFields = ['customerName', 'email'];

    useEffect(() => {
        window.addEventListener("wpsTradeShowPaymentEvent", handleWpsTradeShowPaymentEvent);
        return () => window.removeEventListener("wpsPaymentEvent", handleWpsTradeShowPaymentEvent);
    }, [])

    useEffect(() => {
        const addressFileds = ['addressLine1', 'city', 'state', 'zip', 'countryCode'];
        const anyFieldFilled = addressFileds.some(field => userDetails[field].trim() !== '');
        setIsAnyAddressFieldFilled(anyFieldFilled);
    }, [userDetails]);

    const handleWpsTradeShowPaymentEvent = (event) => {
        if (event.success) {
            setIsError(false);
            setIsSuccess(true);
            setPaymentResult(event.success);
        }
        if (event.error) {
            if (event.error.errorMessage) {
                setPaymentError(event.error.errorMessage);
            }
            else {
                setIsSuccess(false);
                setIsError(true);
                setPaymentResult(event.error);
            }
        }
    }


    const validateForm = () => {
        const tempErrors = {};
        let isValid = true;

        requiredFields.forEach((field) => {
            if (!userDetails[field] || userDetails[field].trim() === '') {
                tempErrors[field] = `${field} is required.`;
                isValid = false;
            }
        });

        if (isAnyAddressFieldFilled) {
            const addressFields = ['addressLine1', 'city', 'state', 'zip', 'countryCode'];
            addressFields.forEach((field) => {
                if (!userDetails[field] || userDetails[field].trim() === '') {
                    tempErrors[field] = `${field} is required.`;
                    isValid = false;
                }
            });
        }

        //if no address fields are filled, show error
        if (!isAnyAddressFieldFilled) {     
            const addressFields = ['addressLine1', 'city', 'state', 'zip', 'countryCode'];
            addressFields.forEach((field) => {  
                if (!userDetails[field] || userDetails[field].trim() === '') {
                    tempErrors[field] = `${field} is required.`;
                    isValid = false;
                }
            });
        }

        setErrField(tempErrors);
        return isValid;
    }

    const handleNext = (e) => {
        e.preventDefault();

        const isFormValid = validateForm();
        if (!isFormValid) {
            return;
        }

        if (step === 1) {
            setIsLoading(true);
            for (const [key, value] of Object.entries(userDetails)) {
                if (value.trim() === '' && requiredFields.includes(key)) {
                    setErrorField(key);
                    return;
                }
            }
            setErrorField('');
            userDetails.timestamp = (Math.floor(Date.now() / 1000)).toString();
            const postURL = `${baseURL}/testclient/v1/transaction/paynow`;
            axios.post(postURL, userDetails)
                .then(response => {
                    setIsLoading(false);
                    setPaymentReference(response.data.paymentReference);
                    setPaymentToken(response.data.paymentToken);
                })
                .catch((err) => {
                    console.error("error", err);
                    setPaymentError(err.response.data.message || 'An error occurred while processing the payment.');
                    setIsLoading(false);
                });
        }
        setStep((prevStep) => prevStep + 1);
    };

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setUserDetails(({
            ...userDetails,
            [name]: value,
        }));

        if (errField[name]) {
            setErrField((prevErr) => ({
                ...prevErr,
                [name]: '',
            }));
        }
        if (name === errorField && value.trim() !== '') {
            setErrorField('');
        }
    };

    const getErrorMessage = (fieldName) => {
        if (errField[fieldName]) {

            //make first letter of fieldName capital
            const capitalizedFieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
            return `${capitalizedFieldName} is required.`;
        }
    };

    useEffect(() => {
        const wpsTradeshowComponentScript = document.getElementById('wpsTradeshowComponentScript');
        wpsTradeshowComponentScript.src = env.REACT_APP_WPS_TRADESHOW_PAYMENT_URL;
        if (!wpsTradeshowComponentScript.src) {
            console.log(`Warning----> REACT_APP_WPS_TRADESHOW_PAYMENT_URL not found`);
        }
    }, []);

    return (
        <>
            <div className="global-tradeshow-solution">
                <div className="steps-container">
                    <div className={`step-label ${step === 1 ? 'active' : ''}`}>
                        <div className="step-description">
                            <h3>1. User Details</h3>
                        </div>
                        {step === 1 && (
                            <div className="step-content">
                                <form>
                                    <div>
                                        <label htmlFor="customerName">
                                            <span>Name<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="customerName"
                                            id="customerName"
                                            value={userDetails.customerName}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('customerName') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('customerName')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="countryCode">
                                            <span>Country<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="countryCode"
                                            id="countryCode"
                                            value={userDetails.countryCode || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('countryCode') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('countryCode')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="addressLine1">
                                            <span>Address Line 1<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="addressLine1"
                                            id="addressLine1"
                                            value={userDetails.addressLine1 || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('addressLine1') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('addressLine1')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="addressLine2">
                                            Address Line 2:
                                        </label>
                                        <input
                                            type="text"
                                            name="addressLine2"
                                            id="addressLine2"
                                            value={userDetails.addressLine2 || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="zip">
                                            <span>Postal Code / Postcode / ZIP Code<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="zip"
                                            id="zip"
                                            value={userDetails.zip || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('zip') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('zip')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="city">
                                            <span>City<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="city"
                                            id="city"
                                            value={userDetails.city || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('city') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('city')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="state">
                                            <span>State/Province/Region<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="state"
                                            id="state"
                                            value={userDetails.state || ''}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('state') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('state')}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label htmlFor="phone">
                                            Phone Number:
                                        </label>
                                        <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            value={userDetails.phone || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="email">
                                            <span>Email<span style={{ color: 'red' }}>*</span> :</span>
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            id="email"
                                            value={userDetails.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        {getErrorMessage('email') && (
                                            <p style={{ color: 'red' }}>{getErrorMessage('email')}</p>
                                        )}
                                    </div>
                                </form>
                                <div className="checkbox-container">
                                    <div className='checkbox-item'>
                                        <input
                                            type="checkbox"
                                            id="simulatePayment"
                                            name="simulatePayment"
                                            checked={simulatePayment || false}
                                            onChange={(e) => setSimulatePayment(e.target.checked)}
                                        />
                                        <label htmlFor="simulatePayment">Simulate Payment</label>
                                    </div>
                                    <div className='checkbox-item'>
                                        <input
                                            type="checkbox"
                                            id="supplyButtonId"
                                            name="supplyButtonId"
                                            checked={supplyButtonId || false}
                                            onChange={(e) => setSupplyButtonId(e.target.checked)}
                                        />
                                        <label htmlFor="supplyButtonId">Test Harness Payment Button</label>
                                    </div>
                                </div>

                                <button className="global-tradeshow-button" onClick={handleNext}>Proceed to payment</button>
                            </div>
                        )}
                        {step !== 1 && (
                            <div className="step-content">
                                <p>{userDetails.customerName}</p>
                                <p>{userDetails.addressLine1}</p>
                                <p>{userDetails.addressLine2}</p>
                                <p>{userDetails.city}, {userDetails.state}</p>
                                <p>{userDetails.countryCode}, {userDetails.zip}</p>
                                <p>{userDetails.phone}</p>
                                <p>{userDetails.email}</p>
                            </div>
                        )}
                    </div>
                    <div className={`step-label ${step === 2 ? 'active' : ''}`}>
                        <div className="step-description">
                            <h3>2. Payment</h3>
                        </div>

                        {step === 2 && (
                            paymentError ?
                                <div id="wps-payment-error">
                                    <p style={{ color: "red" }}>Payment Failed, {paymentError}</p>
                                </div>
                                :
                                <div className="step-content">
                                    {isLoading && <div className='global-tradeshow-loader'></div>}
                                    {paymentToken && paymentReference &&
                                        <div className="step-description">
                                            <trade-show-payment-component
                                                appId={userDetails.appId}
                                                timestamp={userDetails.timestamp}
                                                region={userDetails.region}
                                                presentmentCurrency={userDetails.presentmentCurrency}
                                                amount={userDetails.amount}
                                                intentType={userDetails.intentType}
                                                paymentToken={paymentToken}
                                                paymentReference={paymentReference}
                                                {...(simulatePayment ? { simulation: true } : {})}
                                                {...supplyButtonId ? { buttonId: 'test-harness-payment-button' } : {}}
                                            />
                                        </div>
                                    }

                                    {supplyButtonId && !paymentResult.length && <button className="global-tradeshow-button" id='test-harness-payment-button'>Save and continue</button>}
                                </div>
                        )}
                    </div>

                    <div className={`step-label ${step === 3 ? 'active' : ''}`}>
                        <h3>3. Order Result</h3>
                        {paymentResult && (
                            <div className="step-content">
                                {isError && <div id="wps-response-form">
                                    <div style={{ padding: "20px" }}>
                                        <h3 style={{ color: "red" }}>There was a problem with your payment!</h3>
                                        <div><textarea id="responseTextarea" readOnly spellCheck="false" style={{ width: "80%", height: "150px" }} value={JSON.stringify(paymentResult, undefined, 4)}></textarea>
                                        </div>
                                    </div>
                                </div>}
                                {isSuccess &&
                                    <div style={{ padding: "20px" }}>
                                        <h3 style={{ color: "green" }}>Thank you for your payment!</h3>
                                        <div><textarea id="responseTextarea" readOnly spellCheck="false" style={{ width: "80%", height: "150px" }} value={JSON.stringify(paymentResult, undefined, 4)}></textarea>
                                        </div>
                                    </div>}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default GlobalTradeshowSolution;